import z from "zod";
import { worksites } from "../../attendances";

export const acknowledgementDefinitionSchema = z.object({
	text: z.string().min(1),
	state: z.enum(["active", "inactive"]),
	worksite: z.enum(worksites),
	projectId: z.uuid().nullish(),
});

export type AcknowledgementDefinitionFormSchema = z.infer<typeof acknowledgementDefinitionSchema>;
